// File: src/components/mixer/Color Mixer UI Components/HeaderAndTimer.jsx
import React, { useEffect, useState } from 'react';

const styles = {
  container: {
    boxSizing: 'border-box',
    maxWidth: 680,
    width: '80%',
    margin: '12px auto 0',
    padding: '0 12px',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    textAlign: 'center',
    color: '#0b0b0b',
  },

  /* Title & Subheading */
  title: {
    margin: 0,
    fontSize: '1.85rem',
    fontWeight: 800,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },
  // ⬇︎ Crooked highlight pill (subtle), with inner text counter-skew
  highlight: {
    display: 'inline-block',
    backgroundColor: '#3579F6',
    color: '#fff',
    padding: '3px 10px',
    paddingBottom: 4,
    borderRadius: 6,
    transform: 'skewX(-6deg) rotate(-2deg)', // more crooked highlight
    marginLeft: 0,
  },
  highlightText: {
    display: 'inline-block',
    transform: 'skewX(6deg) rotate(2deg)', // counter the outer transform so text is straight
  },
  

  subheading: {
    marginTop: 6,
    fontSize: '.9rem',
    color: '#6b7280',
    fontWeight: 500,
    lineHeight: 1.45,
  },

  /* Timer */
  timerWrapper: {
    marginTop: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  timerLabelPill: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 999,
    background: '#fff',
    border: '1px solid #e5e7eb',
    fontSize: '.7rem',
    color: '#374151',
    fontWeight: 800,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    marginBottom: 8,
  },

  digitsRow: { display: 'flex', alignItems: 'baseline', gap: 2 },
  digit: {
    display: 'inline-block',
    fontSize: '2.5rem',
    lineHeight: 1,
    fontWeight: 900,
    letterSpacing: '-0.02em',
    color: '#0f172a',
    fontVariantNumeric: 'tabular-nums',
    marginTop: 8,
  },
  colon: {
    fontSize: '2rem',
    fontWeight: 900,
    color: '#9ca3af',
    lineHeight: 1,
    padding: '8px 4px',
    transform: 'translateY(-5px)',
  },
};

export default function HeaderAndTimer({
  partnerColour = 'BLUE',
  yourColour = 'RED',
  nextRoundStartsAt,
}) {
  const [parts, setParts] = useState({ h: '--', m: '--', s: '--' });

  useEffect(() => {
    if (!nextRoundStartsAt) {
      setParts({ h: '--', m: '--', s: '--' });
      return;
    }
    let timerId;
    const target = new Date(nextRoundStartsAt);

    const tick = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        setParts({ h: '00', m: '00', s: '00' });
        clearInterval(timerId);
        return;
      }
      const total = Math.floor(diff / 1000);
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      setParts({
        h: String(h).padStart(2, '0'),
        m: String(m).padStart(2, '0'),
        s: String(s).padStart(2, '0'),
      });
    };

    tick();
    timerId = setInterval(tick, 1000);
    return () => clearInterval(timerId);
  }, [nextRoundStartsAt]);

  const hasHours = parts.h !== '00' && parts.h !== '--';

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        Find a{' '}
        <span style={styles.highlight}>
          <span style={styles.highlightText}>Partner</span>
        </span>
      </h1>

      <div style={styles.subheading}>
        You are {yourColour}. Find a {partnerColour} partner and enter their
        code — or give them your code.
      </div>

      <div style={styles.timerWrapper}>
        <div style={styles.timerLabelPill}>Timer Ends IN</div>

        <div style={styles.digitsRow} aria-live="polite">
          {hasHours && (
            <>
              <span style={styles.digit}>{parts.h[0]}</span>
              <span style={styles.digit}>{parts.h[1]}</span>
              <span style={styles.colon}>:</span>
            </>
          )}
          <span style={styles.digit}>{parts.m[0]}</span>
          <span style={styles.digit}>{parts.m[1]}</span>
          <span style={styles.colon}>:</span>
          <span style={styles.digit}>{parts.s[0]}</span>
          <span style={styles.digit}>{parts.s[1]}</span>
        </div>
      </div>
    </div>
  );
}
